export default __webpack_public_path__ + "static/media/IMG28.9a06e77b.jpeg";